<template>
  <a-modal
    :visible="visible"
    title="上传处方"
    okText="上传"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
    :maskClosable="false"
    class="uploadPrescription"
    :bodyStyle="{ padding: '17px 22px' }"
  >
    <div class="title"><img :src="guide" alt="" /></div>
    <div class="guide">
      <img :src="info" alt="" />
      <img :src="pic" alt="" />
      <img :src="text" alt="" />
    </div>
    <div class="tips">提交后系统将自动进行OCR文字识别，稍等即可读取处方信息。</div>
    <div class="title"><img :src="style" alt="" /></div>
    <div class="example"><img :src="example" alt="" /></div>
    <input
      v-show="false"
      ref="fileUploader"
      type="file"
      :multiple="multiple"
      @change="fileChange"
    />
  </a-modal>
</template>

<script setup>
import { defineEmits, defineExpose, reactive, ref } from 'vue'
import guide from '@/assets/img/prescription/operation_guide.png'
import info from '@/assets/img/prescription/info.png'
import pic from '@/assets/img/prescription/pic.png'
import text from '@/assets/img/prescription/text.png'
import style from '@/assets/img/prescription/style.png'
import example from '@/assets/img/prescription/example.png'
import axios from 'axios'
import { message } from 'ant-design-vue'
import { getToken, TokenKey } from '@/utils/auth'
const emit = defineEmits(['handleOrcUpload'])
const FILE_STATUS = {
  EMPTY: 0, // 空
  SUCCESS: 1, // 上传成功
  ERROR: 2, // 上传失败
  UPLOADING: 3 // 上传中
}
const visible = ref(false)
const fileUploader = ref(null)
const maxSize = ref(10)
// 组件状态
const state = reactive({
  fileData: [], // 初始文件
  fileStatus: FILE_STATUS.ERROR, // 文件上传状态
  fileList: [], // 当前文件列表
  fileIndex: 0, // 文件处理索引（处理进度索引）
  rawFile: null // 保存原始文件对象（用于OCR识别）
})

const setVisible = data => {
  visible.value = data
}

const handleOk = () => {
  setVisible(false)
  emit('handleOrcUpload')
}

const handleCancel = () => {
  setVisible(false)
}

const onUpload = () => {
  triggerFileUpload()
}

const triggerFileUpload = () => {
  if (fileUploader.value) {
    fileUploader.value.click()
  }
}

// 上传之前校验文件是否符合要求
const beforeUpload = files => {
  const lists = []
  return new Promise(resolve => {
    for (var i = 0; i < files.length; i++) {
      const file = files[i]
      const isSupportType = ['image/jpeg', 'image/png'].includes(file.type)
      const isLtSize = file.size / 1024 / 1024 < maxSize.value
      if (!isSupportType) {
        message.error('请上传 JPG/PNG 格式图片!')
      } else if (!isLtSize) {
        message.error(`请上传${maxSize.value}MB以内的图片`)
      } else {
        lists.push(file)
      }
    }
    resolve(lists)
  })
}
let TargetVal = ''
// 上传前处理
const fileChange = async e => {
  TargetVal = e.target
  const files = TargetVal.files
  if (files && files.length) {
    // 保存原始文件对象（用于OCR识别）
    state.rawFile = files[0]
    beforeUpload(files)
      .then(list => {
        if (list && list.length) {
          // 依次开始上传
          state.fileStatus = FILE_STATUS.UPLOADING
          state.fileList = list
          state.fileIndex = 0
          uploadFile(state.fileList[state.fileIndex])
        }
      })
      .catch(() => {
        //
      })
  }
}
// 上传文件
const uploadFile = async file => {
  try {
    const fd = new FormData()
    fd.append('files', file)
    fd.append('type', 4)
    axios({
      url: process.env.VUE_APP_BASE_API + '/file/upload/batch',
      method: 'post',
      data: fd,
      headers: {
        [TokenKey]: getToken(),
        'content-type': 'multipart/form-data'
      }
    }).then(async res => {
      const { data = [], code = '0' } = res.data
      if (code == 0) {
        data[0].mode = 'read'
        state.fileData.push(data[0])
        state.fileIndex++
        isFinish()
          .then(() => {
            state.fileStatus = FILE_STATUS.SUCCESS
            // 传递文件列表、索引和原始文件对象（用于OCR识别）
            emit('onSuccess', state.fileData, 'ocrImgUrlList', state.rawFile)
            state.fileList = []
            state.fileIndex = 0
            state.rawFile = null
            TargetVal.value = ''
          })
          .catch(() => {
            TargetVal.value = ''
          })
      } else {
        message.error(`${file.name}在上传过程中发生错误，上传中止`)
      }
    })
  } catch (err) {
    state.fileStatus = FILE_STATUS.ERROR
    state.fileList = []
    message.error(`${file.name}在上传过程中发生错误，上传中止`)
  }
}

// 遍历所有文件
const isFinish = () => {
  return new Promise(resolve => {
    console.log('isFinish')
    resolve(FILE_STATUS.SUCCESS)
  })
}

defineExpose({
  setVisible
})
</script>

<style scoped lang="scss">
.uploadPrescription {
  img {
    width: 100%;
    height: 100%;
  }
  .title {
    width: 105px;
    height: 23px;
    margin-bottom: 21px;
  }
  .guide {
    display: flex;
    justify-content: center;
    margin-bottom: 23px;
    img {
      width: 82px;
      height: 91px;
      margin-right: 33px;
    }
  }
  .tips {
    padding: 8px 20px;
    color: #2b4a83;
    border-radius: 8px;
    background-color: #f9fbff;
    border: 1px solid #e4effd;
    margin-bottom: 24px;
  }
  .example {
    display: flex;
    justify-content: center;
    img {
      width: 319px;
      height: 174px;
    }
  }
}
</style>
